import { createSelector } from 'reselect'
import { isLegacyWorkspace } from './billing'
import { getAPIUsageBySourceIDForCurrentPeriod } from './legacy-api-usage'
import { getMTUsForCurrentPeriodBySourceId } from './mtus'

const passThroughArgs = (...args) => args

const getUsageBySourceID = createSelector(
  [ isLegacyWorkspace, passThroughArgs ],
  (isLegacy, args) => isLegacy
    ? getAPIUsageBySourceIDForCurrentPeriod(...args)
    : getMTUsForCurrentPeriodBySourceId(...args)
)

/**
 * Get normalized usage totals for current period by source ID
 * Api-calls for legacy plans and MTUs for non-legacy plans
 *
 * @param {Object} state
 * @param {String} workspaceSlug
 * @param {String} sourceId
 * @return {Object}
 */

export const getUsageForCurrentPeriod = createSelector(
  [ isLegacyWorkspace, getUsageBySourceID ],
  (isLegacy, usage) => {
    if (!usage) return null

    if (isLegacy) {
      return {
        type: 'API Calls',
        count: usage.calls,
        period: usage.periodStart
      }
    } else {
      return {
        type: 'MTUs',
        count: usage.counts.users + usage.counts.anonymous,
        period: usage.period
      }
    }
  }
)



// WEBPACK FOOTER //
// ./selectors/usage.js